<template>
  <form data-vv-scope="change-owner-form" @submit.prevent="save">
    <div class="row">
      <div class="col-md-12">
        <list-user
          class="w-100"
          autocomplete
          name="propietario"
          placeholder="Elija un nuevo propietario"
          v-model="newOwner"
          ref="propietario"
          :danger="errors.has('change-owner-form.propietario')"
          :danger-text="errors.first('change-owner-form.propietario')"
          v-validate="'required'"
          @input="getUserId"
        />
      </div>
    </div>
    <div class="m-top-20 d-flex justify-end">
      <vs-button
        class="mt-5 ml-3"
        @click="save()"
        color="primary"
        type="border"
      >
        Editar
        <span v-show="loading" class="spinner-border spinner-border-sm text-white" />
      </vs-button>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { ioEDFilesGet, ioEDFoldersGet } from '@/febos/servicios/api/repositories.api';
import ListUser from '@/febos/chile/lists/components/ListUser';

export default {
  name: 'ChangeOwnerModal',
  components: {
    ListUser
  },
  data() {
    return {
      loading: false,
      newOwner: null,
    };
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getSelectedElement',
    ]),
  },
  methods: {
    ...mapActions('DocManagement', [
      'changeFolderOwner',
      'changeFileOwner',
    ]),
    getUserId(event) {
      this.newOwner = event;
    },
    async save() {
      if (this.loading) {
        return;
      }
      const formCheck = await this.$validator.validateAll('change-owner-form');
      if (formCheck) {
        this.loading = true;
        const key = this.getSelectedElement.type === 'folder' ? 'folderId' : 'fileId';
        const body = {
          repositoryId: this.getSelectedElement.repositoryId,
          [key]: this.getSelectedElement.id,
          ownerId: this.newOwner
        };
        const modifiedElement = this.getSelectedElement;
        if (this.getSelectedElement.type === 'folder') {
          await this.changeFolderOwner(body);
          const response = await ioEDFoldersGet({
            repositoryId: this.getSelectedElement.repositoryId,
            folderId: this.getSelectedElement.id
          });
          modifiedElement.owner = response.data.propietario.nombre;
          modifiedElement.ownerId = response.data.propietario.id;
        } else if (this.getSelectedElement.type === 'file') {
          await this.changeFileOwner(body);
          const response = await ioEDFilesGet({
            repositoryId: this.getSelectedElement.repositoryId,
            fileId: this.getSelectedElement.id
          });
          modifiedElement.owner = response.data.archivo.propietario.nombre;
          modifiedElement.ownerId = response.data.archivo.propietario.id;
        }
        this.$store.commit('DocManagement/SET_SELECTED_ELEMENT', modifiedElement);
        this.$bvToast.toast(
          'El propietario(a) ha sido modificado correctamente',
          {
            title: 'Editar',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 15000
          }
        );
        this.loading = false;
        this.$emit('close');
      }
    }
  },
};
</script>
